module.exports = __webpack_public_path__ + "img/screen4.853e55da.jpg";